<template>
  <tr>
    <th>
      <button
        v-if="plusButtonDisplayYn"
        type="button"
        class="btn-expand"
        :class="{
          'is-more': isShowCategoryMore,
          'is-expand': isShowCategoryMore,
        }"
        @click="() => (isShowCategoryMore = !isShowCategoryMore)"
      >
        <span class="text">{{ props.categoryName }}</span>
        <span class="sr-only">펼침</span>
        <i
          class="c-icon icon-plus-black size-xxsmall"
          :style="{ display: plusButtonDisplay }"
        ></i>
      </button>
      <span v-else class="text">{{ props.categoryName }}</span>
    </th>
    <td>
      <div
        v-show="categories.length > 0"
        class="options"
        :class="{ 'is-visible': isShowCategoryMore }"
        :style="{ height: moreStyle }"
        ref="categoryEl"
      >
        <div class="option-inner">
          <!-- D: 클릭시 is-active -->
          <button
            v-for="item in categories"
            :key="item.clsfCd"
            type="button"
            class="c-option-item"
            :class="{
              'is-active': item.selected,
            }"
            @click="changeSelect(item)"
          >
            <span class="text"
              >{{ item[props.clsfNmField] }}(<span class="system">{{
                Utils.currency(item.productCount)
              }}</span
              >)
            </span>
          </button>
        </div>
      </div>
    </td>
  </tr>
</template>
<script setup>
import {
  onMounted,
  defineModel,
  defineProps,
  ref,
  computed,
  defineEmits,
  onBeforeUnmount,
} from "vue";
import Utils from "@/js/utils";

const emits = defineEmits(["selectChanged"]);
const categories = defineModel("categories", { required: true });

const props = defineProps({
  categoryName: {
    type: String,
    default: "",
  },
  clsfNmField: {
    type: String,
    default: "clsfNm",
  },
  categoryFlag: {
    type: String,
    default: "categoryFlag",
  },
});

const isShowCategoryMore = ref(false);
const categoryEl = ref();
const categorySize = ref({
  clientHeight: 0,
  scrollHeight: 0,
});

onMounted(() => {
  window.addEventListener("resize", onWindowResize);
  onWindowResize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onWindowResize);
});

const onWindowResize = () => {
  categorySize.value = {
    clientHeight: categoryEl.value.clientHeight,
    scrollHeight: categoryEl.value.scrollHeight,
  };
};

const plusButtonDisplay = computed(() => {
  //const ROW_HEIGHT = 70; // 1행의 높이는 대략 62이라 약간 더 높은 기준을 설정합니다.
  //return categorySize.value.scrollHeight > ROW_HEIGHT ? "inline" : "none";
  return "inline";
});

const plusButtonDisplayYn = computed(() => {
  //const ROW_HEIGHT = 70; // 1행의 높이는 대략 62이라 약간 더 높은 기준을 설정합니다.

  //return categorySize.value.scrollHeight > ROW_HEIGHT ? true : false;
  return true;
});

const moreStyle = computed(() => {
  return isShowCategoryMore.value ? "inherit" : "62px";
});

const changeSelect = (item) => {
  item.selected = !item.selected;
  emits("selectChanged", categorySize.value);
};
</script>
